module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_BlackMatted_MockedUp.94da2ae8.jpg";